import { motion } from 'framer-motion';

const SwapFlipButton = ({ onFlip }) => {
  return (
    <div className="lr-swap-toggle-row lr-swap-divider-modern">
      <motion.button
        className="lr-swap-toggle lr-flip-button-modern"
        onClick={onFlip}
        data-press
        whileHover={{ 
          rotate: 180,
          scale: 1.1,
          transition: { duration: 0.4 }
        }}
        whileTap={{ 
          scale: 0.9,
          rotate: 180
        }}
      >
        <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
          <path d="M12 4l-1.41 1.41L14.17 9H4v2h10.17l-3.58 3.59L12 16l6-6-6-6zm0 16l1.41-1.41L9.83 15H20v-2H9.83l3.58-3.59L12 8l-6 6 6 6z"/>
        </svg>
      </motion.button>
    </div>
  );
};

export default SwapFlipButton;
